<admin-app-header></admin-app-header>

<div *ngIf="invoices.length > 0">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-2">
                <h2 class="float-start d-inline-block">Duplicate First Invoices</h2>
            </div>
            <div class="col-md-2 ms-auto">
                <button (click)="globalService.exportcsv('duplicate-invoices')" class="btn btn-info btn-sm text-white float-end px-3 py-1 my-2"><i class="fas fa-file-csv"></i> Export to CSV</button>
            </div>
        </div>

        <div class="content col-lg-12">
            <table class="table table-striped table-hover table-sm" id="duplicate-invoices">
                <thead>
                    <tr>
                        <th scope="col">Created Date</th>
                        <th scope="col">Payment Type</th>
                        <th scope="col">Due Date</th>
                        <th scope="col">Invoice Status</th>
                        <th scope="col">Payout Status</th>
                        <th scope="col">Batch Status</th>
                        <th scope="col">Invoice</th>
                        <th scope="col">Portfolio</th>
                        <th scope="col">Parking</th>
                        <th scope="col">Client</th>
                        <th scope="col">Bays</th>
                        <th scope="col">Total</th>
                        <th scope="col">Reference</th>
                        <th scope="col">Subscription</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let invoice of invoices">
                        <tr (contextmenu)="showContextMenu($event, invoice)" [ngClass]="{ selected: selectedInvoice === invoice }">
                            <td>
                                <ng-container *ngIf="invoice.clientRef">
                                    <a [routerLink]="['/client', invoice.clientRef.id, AngularRoutes.INVOICE, invoice.$key]">
                                        {{ invoice.createdAt | formatDate }}
                                    </a>
                                </ng-container>
                            </td>
                            <td>
                                <span class="badge" [ngClass]="EnumNames.getSubscriptionTypeClass(invoice.paymentMethodType)">
                                    {{ EnumNames.getSubscriptionType(invoice.paymentMethodType) }}
                                </span>
                            </td>
                            <td>
                                {{ invoice.dueDate | formatDate }}
                            </td>
                            <td>
                                <span [ngClass]="invoice.getStatusClass()" class="badge"> {{ invoice.status | titlecase }} </span>&nbsp;
                                <span *ngIf="invoice.paygateAttempts" class="badge bg-danger"> Fail: {{ invoice.paygateAttempts }} </span>
                            </td>
                            <td>
                                <ng-container *ngIf="!invoice.payoutRef">
                                    <span *ngIf="!invoice.paidOut" class="badge bg-warning">Not Paid Out</span>
                                </ng-container>
                                <ng-container *ngIf="invoice.payoutRef">
                                    <span [routerLink]="['/admin', 'payout', invoice.payoutRef.id]" class="badge bg-success">
                                        {{ invoice.payoutRef.id | slice: 0:5 }}
                                    </span>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="!invoice.payoutRef">
                                    <span class="badge bg-warning">Not Batched</span>
                                </ng-container>
                                <ng-container *ngIf="invoice.payoutRef">
                                    <span [routerLink]="['/admin', 'payout', invoice.payoutRef.id]" class="badge bg-success"> Batched </span>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="invoice.clientRef">
                                    <a [routerLink]="['/', AngularRoutes.client, invoice.clientRef.id, AngularRoutes.INVOICE, invoice.$key]" class="text-decoration-underline">
                                        INV-{{ invoice.invoiceNumber }}
                                    </a>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="invoice.merchantRef">
                                    <a [routerLink]="['/', AngularRoutes.MERCHANT, invoice.merchantRef.id]" class="text-decoration-underline">
                                        {{ invoice.denormMerchantCompanyName }}
                                    </a>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="invoice.parkingRef">
                                    <a [routerLink]="['/', AngularRoutes.parking, invoice.parkingRef.id]" class="text-decoration-underline">
                                        {{ invoice.denormParkingTitle | truncate: [50] }}
                                    </a>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="invoice.clientRef">
                                    <a [routerLink]="['/', AngularRoutes.client, invoice.clientRef.id, 'invoices']" class="text-decoration-underline">
                                        {{ invoice.denormClientFirstName }} {{ invoice.denormClientLastName }}
                                    </a>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="invoice.clientRef">
                                    {{ invoice.baysBooked }}
                                </ng-container>
                            </td>
                            <td>
                                {{ invoice.amountTotalDue }}
                            </td>
                            <td>
                                {{ invoice.reference }}
                            </td>
                            <td>
                                <a [routerLink]="['/admin', 'subscription', invoice.subscriptionRef?.id]" class="text-decoration-underline">
                                    {{ invoice.subscriptionRef?.id }}
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
